import { render, staticRenderFns } from "./GameActions.vue?vue&type=template&id=69ad31e4&scoped=true&"
import script from "./GameActions.vue?vue&type=script&lang=js&"
export * from "./GameActions.vue?vue&type=script&lang=js&"
import style0 from "./GameActions.vue?vue&type=style&index=0&id=69ad31e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ad31e4",
  null
  
)

export default component.exports